import { tWithKeyAttr as t } from "../../i18nHelper";
import styles from "./groupMembersList.module.css";
import React from "react";
import { ITreatmentGroupMember } from "../../services/types/utils.types";

interface GroupMembersListProps {
  members: ITreatmentGroupMember[];
  title?: string;
  maxParticipants?: number | null;
  onRemoveMember?: (member: ITreatmentGroupMember) => void;
}

function GroupMembersList({ 
  members, 
  title,
  maxParticipants,
  onRemoveMember
}: GroupMembersListProps) {
  return (
    <article className={`section ${styles.section}`}>
      {title && (
        <h3 className="sectionTitle">
          {title} ({members.length}/{maxParticipants ?? t('UNLIMITED')})
        </h3>
      )}
      <ul className="list">
        <li 
          className={`listRow listRow_header ${styles.member}`}
          style={onRemoveMember ? { gridTemplateColumns: "60px 1fr 120px 1.5fr 100px 50px" } : undefined}
        >
          <p className="listCell">{t('COLUMN_ID')}</p>
          <p className="listCell">{t('NAME_2')}</p>
          <p className="listCell">{t('PHONE')}</p>
          <p className="listCell">{t('EMAIL')}</p>
          <p className="listCell">{t('JOINED_DATE')}</p>
          {onRemoveMember && <p className="listCell"></p>}
        </li>
        {members?.length > 0 && (
          members.map((member, index) => (
            <li
              key={member.id || member.userId}
              className={`listRow ${styles.member} ${index % 2 === 0 ? 'colored' : ''}`}
              style={onRemoveMember ? { gridTemplateColumns: "60px 1fr 120px 1.5fr 100px 50px" } : undefined}
            >
              <p className="listCell">{member.userId}</p>
              <p className="listCell">{member.userFullName || '-'}</p>
              <p className="listCell">{member.userPhone || '-'}</p>
              <p className="listCell">{member.userEmail || '-'}</p>
              <p className="listCell">
                {member.joinedDate 
                  ? new Date(member.joinedDate).toLocaleDateString('he-IL')
                  : '-'
                }
              </p>
              {onRemoveMember && (
                <div className="listCell" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <button
                    type="button"
                    className="btn btn_type_delete"
                    onClick={() => onRemoveMember(member)}
                    title={t('REMOVE_MEMBER')}
                  />
                </div>
              )}
            </li>
          ))
        )}
        {!members?.length && (
          <li className={`listRow ${styles.member}`}>
            <p className={`listCell ${styles.emptyRow}`} style={{ gridColumn: '1 / -1' }}>
              {t('NO_MEMBERS_IN_GROUP')}
            </p>
          </li>
        )}
      </ul>
    </article>
  );
}

export default GroupMembersList;
